import { FaTimes } from "react-icons/fa";

import one from "./assets/tutorial/one.png";
import two from "./assets/tutorial/two.png";
import three from "./assets/tutorial/three.png";
import four from "./assets/tutorial/four.png";
import five from "./assets/tutorial/five.png";
import six from "./assets/tutorial/six.png";

const TUTORIAL_STEPS = [
  {
    title: "Learn the navigation",
    body: "Use the top navigation to move between setup areas. Start in Players, Staff, and Session to prepare your club before opening tables on the Game dashboard.",
    imageLabel: "Game dashboard navigation screenshot",
    image: one,
    imageAlt: "Game Dashboard screenshot with navigation highlighted",
  },
  {
    title: "Add your players",
    body: "Add players one at a time, or upload a CSV file if you already have an existing player list.",
    imageLabel: "Players page screenshot",
    image: two,
    imageAlt: "Players page",
  },
  {
    title: "Add dealers and staff",
    body: "Add dealers for tips and payouts. You can also add other staff, such as employees, who may receive chips as tips during a session.",
    imageLabel: "Staff page screenshot",
    image: three,
    imageAlt: "Staff page",
  },
  {
    title: "Add wallets",
    body: "Add wallets for electronic payment methods so deposits, withdrawals, costs, and tips can be tracked correctly. Wallets only need to be added once.",
    imageLabel: "Session page wallets screenshot",
    image: four,
    imageAlt: "Session page wallets section",
  },
  {
    title: "Start your first session",
    body: "The Session page is your hub for session-level information. Start the session here and use the cash bag to track how much physical cash you are holding.",
    imageLabel: "Session page start session and cash bag screenshot",
    image: five,
    imageAlt: "Session page start session button and cash bag",
  },
  {
    title: "Create tables on the Game dashboard",
    body: "Once a session is active, return to the Game dashboard to create tables, seat players, and start your table by clicking on the green icon in table's header.",
    imageLabel: "Game dashboard table creation screenshot",
    image: six,
    imageAlt: "Game dashboard after session is started",
  },
];

export default function GameTutorialModal({ onClose, onConfirm }) {
  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
      return;
    }
    onClose();
  };

  return (
    <>
      <div className="game-modal-overlay" />
      <div className="game-modal game-modal--large game-tutorial-modal">
        <div className="game-modal__header">
          <div>
            <p className="game-tutorial-modal__eyebrow">Getting started</p>
            <h3 className="game-modal__title">Nexus Game Engine Tutorial</h3>
          </div>
          <button
            type="button"
            className="game-icon-btn"
            onClick={onClose}
            aria-label="Close tutorial"
          >
            <FaTimes />
          </button>
        </div>

        <div className="game-modal__body game-modal__body--scroll">
          <p className="game-tutorial-modal__intro">
            Follow these steps to set up your first session and begin using the
            game dashboard. This setup guide and the full Software
            Guide is available in Admin.
          </p>

          <div className="game-tutorial-steps">
            {TUTORIAL_STEPS.map((step, index) => (
              <section className="game-tutorial-step" key={step.title}>
                <div className="game-tutorial-step__image">
                  {step.image ? (
                    <img src={step.image} alt={step.imageAlt || step.title} />
                  ) : (
                    <span>{step.imageLabel}</span>
                  )}
                </div>
                <div className="game-tutorial-step__content">
                  <span className="game-tutorial-step__number">
                    Step {index + 1}
                  </span>
                  <h4>{step.title}</h4>
                  <p>{step.body}</p>
                </div>
              </section>
            ))}
          </div>
        </div>

        <div className="game-modal__footer">
          <button
            type="button"
            className="game-btn game-btn--primary"
            onClick={handleConfirm}
          >
            Got it
          </button>
        </div>
      </div>
    </>
  );
}
